import React from 'react';

import IconType from '../IconType';
import SVGIcon from '../SVGIcon';

const CSS = require('./ChevronIcon.module.scss');

type ChevronIconProps = {
  direction?: 'right' | 'left' | 'up' | 'down';
  variant?:
    | 'black'
    | 'pink'
    | 'purple'
    | 'dark-green'
    | 'inbetween-gray'
    | 'gray'
    | 'white';
} & IconType;

function ChevronIcon({
  direction = 'right',
  variant,
  ...props
}: ChevronIconProps) {
  return (
    <SVGIcon
      {...props}
      direction={direction}
      size={props.size ?? 24}
      viewBox="0 0 24 24"
      rotationOffset={0}
    >
      <path
        d="M8.10430458,5.09261652 C8.59245994,4.60446116 9.38391616,4.60446116 9.87207153,5.09261652 L15.8716954,11.0922404 C16.3598292,11.5803741 16.359854,12.3717876 15.8717508,12.859952 L9.87212693,18.8603281 C9.38400217,19.348514 8.59254595,19.3485636 8.10435998,18.8604389 C7.61617402,18.3723141 7.61612441,17.5808579 8.10424917,17.0926719 L13.2191881,11.9755 L8.10430458,6.86038348 C7.6486929,6.4047718 7.61831879,5.68495138 8.01318224,5.19411187 L8.10430458,5.09261652 Z"
        data-variant={variant}
        className={CSS.Chevron}
      />
    </SVGIcon>
  );
}

export default ChevronIcon;
